
// Validation functions for auth

// Validate email format
export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate password strength
export const isValidPassword = (password: string): boolean => {
  // Password should be at least 8 characters long and contain at least one number
  const passwordRegex = /^(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
};

// Validate user credentials
export const validateCredentials = (email: string, password: string): boolean => {
  console.log(`Validating credentials for: ${email}`);
  
  // Get user data to check if the account exists and if the email is verified
  const userDataString = localStorage.getItem(`userData_${email}`);
  if (!userDataString) {
    console.log("User data not found");
    return false;
  }
  
  try {
    const userData = JSON.parse(userDataString);
    console.log("User data retrieved:", userData);
    
    // Check if email is verified
    if (!userData.isEmailVerified) {
      console.log("Email not verified");
      return false;
    }
    
    // Retrieve stored password for this email
    const storedPassword = localStorage.getItem(`user_${email}`);
    
    // Log the comparison (don't log actual passwords in production)
    console.log("Password check result:", storedPassword === password);
    
    // Return true if credentials match
    return storedPassword === password;
  } catch (error) {
    console.error("Error parsing user data:", error);
    return false;
  }
};

// Check if user exists
export const userExists = (email: string): boolean => {
  // Check if user data exists in localStorage
  const userDataString = localStorage.getItem(`userData_${email}`);
  return !!userDataString;
};
